import { useState, useContext } from 'react';
import { Formik } from 'formik';
import { DatePicker, FilterModal, SelectSearch } from 'components';
import { DateConvert } from 'utilities';
import { DropdownContext } from '../context/DropdownContext';

export const ModalFilterPreform = ({ toggle, data, setData }) => {
  const [loading, setLoading] = useState(false);
  const { dropdownOverhead, dropdownAset } = useContext(DropdownContext);
  const option = { label: 'Semua Data', value: undefined };
  const optionAset = [option].concat(dropdownAset?.data ?? []);
  const optionOverhead = [option].concat(dropdownOverhead?.data ?? []);

  const formInitialValues = {
    tgl_work_order_mulai: data.tgl_work_order_mulai,
    tgl_work_order_selesai: data.tgl_work_order_selesai,

    id_item_overhead: data.id_item_overhead,
    id_item_aset: data.id_item_aset,
  };
  const formSubmitHandler = (values) => {
    const checkActive =
      !!Object.values(values).filter((val) => val !== undefined).length > 0;

    setData({
      ...data,
      ...values,
      active: checkActive,
      page: 1,
    });

    toggle();
  };

  const onResetButtonClick = (setValues) => {
    setLoading(true);

    const myPromise = new Promise((resolve) => {
      setValues({
        tgl_work_order_mulai: undefined,
        tgl_work_order_selesai: undefined,
        id_item_overhead: undefined,
        id_item_aset: undefined,
      });

      setTimeout(() => resolve(), 300);
    });

    myPromise.then(() => setLoading(false));
  };

  const onTanggalChange = (
    dates,
    values,
    setValues,
    value_mulai,
    value_selesai,
  ) => {
    const [start, end] = dates;
    const startDate = start ? DateConvert(start).default : null;
    const endDate = end ? DateConvert(end).default : null;

    setValues({
      ...values,
      [value_mulai]: startDate,
      [value_selesai]: endDate,
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={formInitialValues}
      onSubmit={formSubmitHandler}
    >
      {({ values, handleSubmit, setFieldValue, setValues }) => (
        <FilterModal
          isToggle
          toggleModal={toggle}
          onResetButtonClick={() => onResetButtonClick(setValues)}
          onFilterButtonClick={handleSubmit}
        >
          <DatePicker
            selectsRange
            monthsShown={2}
            label="Tgl.  Work Order"
            placeholderText="Pilih Tanggal  Work Order"
            startDate={
              values?.tgl_work_order_mulai
                ? new Date(values?.tgl_work_order_mulai)
                : ''
            }
            endDate={
              values?.tgl_work_order_selesai
                ? new Date(values?.tgl_work_order_selesai)
                : ''
            }
            onChange={(dates) =>
              onTanggalChange(
                dates,
                values,
                setValues,
                'tgl_work_order_mulai',
                'tgl_work_order_selesai',
              )
            }
          />

          <SelectSearch
            label="Item Aset"
            placeholder="Pilih Item Aset"
            defaultValue={optionAset.find(
              (val) => val.value === values.id_item_aset,
            )}
            option={optionAset}
            onChange={(val) => setFieldValue('id_item_aset', val.value)}
            loading={dropdownAset.isLoading || loading}
          />

          <SelectSearch
            label="Item Overhead"
            placeholder="Pilih Item Overhead"
            defaultValue={optionOverhead?.find(
              (val) => val.value === values.id_item_overhead,
            )}
            option={optionOverhead}
            onChange={(val) => setFieldValue('id_item_overhead', val.value)}
            loading={dropdownOverhead?.isLoading || loading}
          />
        </FilterModal>
      )}
    </Formik>
  );
};
